<div [ngClass]="{toTop :toTop == true }" class="bgGray6 premium rounded ">
    <div class="h6 rounded-top py-2 bg1 px-5 text-light">DEVENIR PREMIUM</div>

    <div class="d-flex flex-column justify-content-between align-items-center">
        <div class="mt-2 d-flex flex-column justify-content-between align-items-center ">
            <img class="mb-2"  width="50" src="assets/Icones/Premium1.png" alt="" srcset="">
            <span class="title">Upgrade to pro</span>
            <p  class=" my-3 text-center px-3 description">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, quae?</p>
        </div>
    
        <ul class="px-5 mb-2 avantage ">
            <ol>
                <img  width="10" src="assets/Icones/Avantages1.png" alt="" srcset="">
                    <span>Lorem ipsum dolor sit amet.</span>
            </ol>
            <ol>
                <img  width="10" src="assets/Icones/Avantages1.png" alt="" srcset="">
                    <span>Lorem ipsum dolor sit amet.</span>
            </ol>
            <ol>
                <img  width="10" src="assets/Icones/Avantages1.png" alt="" srcset="">
                    <span>Lorem ipsum dolor sit amet.</span>
            </ol>
        </ul>
    
        <button class="px-3 py-1 my-2 text-white ">Upgrade to pro</button>
    </div>
</div>